import React, { Fragment, useState, useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {
    Card,
    CardBody,
    Container
} from "reactstrap";
import { Col, Row } from "react-bootstrap";
import greenTick from "./assets/img/green_tick_sq.png";
import CommonHeaderContent from '../../Common/CommonHeaderContent';

const CardPanel = (props) => {
    let { name, type, countvalue, sumvalue, openChartConfig, primaryChartType, md, disabled, divStyle } = props;
    return (
        <Col onClick={(e) => { openChartConfig(type) }} md={md} className={`mb-2 sample-primary-card p-0 ml-2 cursor-pointer ${disabled !== undefined && disabled ? 'disable-click' : ''} ${primaryChartType === type ? 'chart-selected' : ''}`}>
            <Card className="main-card border pri-dashboard-card" style={divStyle}>
                <CardBody>
                    {primaryChartType === type && <span className='pd-chart-triangle'>
                        <img className='pd-chat-img-selected' src={greenTick} />
                    </span>
                    }
                    <div className='text-center'>
                        {name}
                        <div className='d-flex-alone f-column'>

                            <span className='primary-data'>{sumvalue}</span>
                            <span>{countvalue} records</span>

                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}

export default CardPanel;